<template>
    <transition
        name="fade"
        appear
    >
        <ul
            class="bg-light rounded shadow-default list-unstyled mb-0 py-16"
            :style="
                $mq.smPlus
                    ? 'max-width: 148px; max-width: fit-content;'
                    : 'width: 100%;'
            "
        >
            <li
                v-for="action in actions"
                :key="action.text"
                class="d-flex align-items-center"
            >
                <button-link
                    :to="action.to"
                    :href="action.href"
                    :download="action.download"
                    class="py-8 px-16 w-100 hover:bg-gray-light"
                    shape="text"
                    theme="dark"
                    @click="emitEvent(action.event)"
                >
                    <v-icon
                        v-if="action.icon"
                        class="mr-4"
                        :name="action.icon"
                        :w="18"
                    />

                    <span class="font-weight-normal font--14">
                        {{ ucfirst(action.text) }}
                    </span>
                </button-link>
            </li>
        </ul>
    </transition>
</template>

<script>
import { ucfirst } from "~/lib/utils"
import ButtonLink from "~/components/buttons/ButtonLink"

export default {
    /**
     *  actions prop structure:
     *      event?:     String
     *      icon?:      String
     *      text:       String
     *      download?:  String
     *      href?:      String
     *      to?:        String | Object
     */
    props: {
        actions: {
            type: Array,
            required: true,
        },
    },

    emits: ["action", "close"],

    methods: {
        emitEvent(event) {
            if (!event) {
                this.$emit("close")
            } else {
                this.$emit("action", event)
            }
        },

        ucfirst,
    },

    components: {
        ButtonLink,
    },
}
</script>
